import { ButtonLink } from '@src/common/components/button/ButtonLink';
import { css } from '@src/common/styles/Styles';

// TODO: To redo
export const UnknownRoute = () => {
  return (
    <main className={container}>
      <h1>Oups, this page does not seem to exists</h1>

      <ButtonLink to="/">Return to Home</ButtonLink>
    </main>
  );
};

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 40px;
`;
